// @ts-nocheck

import { GRStateActionTypes } from '../types/actions/gr';

export const updateGRUserState = ({ userStateMutation }) => ({
  type: GRStateActionTypes.UPDATE_STATE,
  payload: {
    userStateMutation,
  },
});

export const skipAllGRTemporaryNotifications = () => ({
  type: GRStateActionTypes.SKIP_ALL_TMP_NOTIFICATIONS,
});

export const skipCurrentGRTemporaryNotification = () => ({
  type: GRStateActionTypes.SKIP_CURRENT_TMP_NOTIFICATION,
});

export const fillTemporaryGRNotification = () => ({
  type: GRStateActionTypes.FILL_TEMPORARY_NOTIFICATIONS,
});

export const triggerGRNotificationsTransitions = () => ({
  type: GRStateActionTypes.TRIGGER_NOTIFICATIONS_TRANSITIONS,
});

export const cancelNotificationsTransitions = () => ({
  type: GRStateActionTypes.CANCEL_NOTIFICATIONS_TRANSITIONS,
});

export const setGRHomeVisitedIndex = (index) => ({
  type: GRStateActionTypes.SET_HOME_VISITED_INDEX,
  payload: {
    index,
  },
});

export const startGR = () => ({
  type: GRStateActionTypes.START,
});

export const flushGRNotifications = () => ({
  type: GRStateActionTypes.FLUSH_NOTIFICATIONS,
});

export const claimGRReward = ({ uuid }) => ({
  type: GRStateActionTypes.CLAIM_REWARD,
  payload: {
    uuid,
  },
});

export const restartGRRound = () => ({
  type: GRStateActionTypes.RESTART_ROUND,
});
